<template>
  <div class="topbar w-100 d-flex align-items-center justify-content-end">
    <div v-if="user && moduleType" id="topbar-username" class="topbar-username d-flex align-items-center mr-2">
      <div class="symbol bg-light mr-3 module-type-symbol">
        <div class="symbol-label">
          <inline-svg :src="getModuleIconSrc" />
        </div>
      </div>

      <div>
        <h6 class="mb-0">{{ translatedType }}</h6>
        <span class="text-muted user-type">{{ userType }}</span>
      </div>
    </div>
    <QuickUser v-if="headerUserDisplay" />
    <QuickCart v-if="headerCartDisplay" />
  </div>
</template>

<script setup>
/* eslint no-unused-vars:off */
import { ref, onMounted, computed } from "vue";
import QuickCart from "@/view/layout/extras/offcanvas/QuickCart.vue";
import QuickUser from "@/view/layout/extras/offcanvas/QuickUser.vue";
import { useTopbar } from "@/core/composables/topbar";
import identificationService from "@/core/services/identification.service";
import useTranslate from "@/core/composables/translate";

const { translate } = useTranslate();
const { user: topbarUser, headerCartDisplay, headerUserDisplay } = useTopbar();

const user = ref(null);
const moduleType = ref(null);

const getModuleIconSrc = computed(() => identificationService.getModuleIconScr(moduleType.value));
const translatedType = computed(() => translate(`HEADER.MULTI_MODULE.${moduleType.value?.toUpperCase()}`));
const userType = computed(() => translate(`USER_TYPES.${user.value?.getCurrentType()}`));

onMounted(() => {
  user.value = topbarUser.value;
  moduleType.value = user.value?.getCurrentModule();
});
</script>

<style scoped lang="scss">
.topbar {
  .dropdown-toggle {
    padding: 0;

    &:hover {
      text-decoration: none;
    }

    &.dropdown-toggle-no-caret {
      &:after {
        content: none;
      }
    }
  }

  .dropdown-menu {
    margin: 0;
    padding: 0;
    outline: none;

    .b-dropdown-text {
      padding: 0;
    }
  }
}

.user-type {
  font-weight: 400;
}

.module-type-symbol {
  opacity: 0.75;
}

#topbar-username {
  cursor: pointer;
}

.topbar-username {
  font-weight: 500;
  padding: 1rem;
}
</style>
